// GetCurrentTableSRNo fucntion
const GetCurrentTableSRNo = (index, currentPage, itemsPerPage) => {
    return (currentPage - 1) * itemsPerPage + index + 1;
};

export default GetCurrentTableSRNo;
